import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: ["datasets", "options"],
  mounted() {
    this.renderChart(this.datasets, this.options);
  }
};
